import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import imaaage from '../assets/images/post.jpg';
import {ReactComponent as LocationSVG} from '../assets/svgs/location-white.svg'
import {ReactComponent as EmailSVG} from '../assets/svgs/email-white.svg'
import {ReactComponent as PhoneSVG} from '../assets/svgs/phone-white.svg'
import {ReactComponent as PhotoSVG} from '../assets/svgs/photo-white.svg'
import {ReactComponent as WebsiteSVG} from '../assets/svgs/website-white.svg'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import PhotoGallery from '../components/PhotoGallery';
import MapModal from '../components/MapModal';
import 'leaflet/dist/leaflet.css';


const MainContainer = styled.div`
margin: 20px 100px 100px ;

@media (max-width: 768px) {
    margin: 20px 50px 100px; 
  }
  @media (max-width: 480px) {
    margin: 10px 20px 100px;
  }
`;

const Header = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Title = styled.div`
   font-size: 30px;
   display:flex;
   flex-direction:column;
   justify-content: felx-start;
   align-items:center;
   color: #385963;
   font-weight: 600;
   margin: 100px 100px  10px ;
   gap:30px;
   height:500px;

   @media (max-width: 768px) {
    font-size: 28px;
     text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 20px;
    text-align: center; 
  }
`;

const NavContainer = styled("nav")`
  display: flex;
  flex-direction:column;
  justify-content: space-between;
  padding: 30px 20px;
  background-color: transparent;
  position: relative;
  width:100%;
  align-items:center;
 
  @media (max-width: 768px) {
   padding-bottom: 0;
  }

  @media (max-width: 480px) {
   padding-bottom: 0;
  }
`;


const NavTabs = styled("ul")`
  display: flex;
  list-style: none;
  align-items: center;
  gap: 20px;
  padding: 0;

  & > li {
    margin-right: 10px;

    a {
      text-decoration: none;
      color: #385963;
      font-size: 16px; 
      font-weight: 500;
      padding: 10px 0px;
      margin: 0 10px;
      position: relative;

      &:hover {
        color: #91abb3; 
        transition: 0.4s;
      }

      &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 50%;
        background-color: #538392; 
        transition: all 0.4s;
      }

      &:hover::before {
        width: 100%;
        left: 0;
      }

      /* 👇 NEW: selected category style */
      &.selected {
        color: #91abb3;
      }

      &.selected::before {
        width: 100%;
        left: 0;
        background-color: #91abb3;
      }
    }
  }

   @media (max-width: 1200px) {
    flex-direction: column;
    align-items: center;

   li a {
      font-size: 14px;
      white-space: normal;
      text-align: center;
    }
  }

  @media (max-width: 992px) {
   li a {
      font-size: 14px;
      white-space: normal;
      text-align: center;
    }
  }

  @media (max-width: 768px) {
  gap:10px;

  li a {
      font-size: 14px;
      white-space: normal;
      text-align: center;
    }
  }

  @media (max-width: 576px) {
  gap:8px;

  li  a {
      font-size: 10px;
      white-space: normal;
      text-align: center;
    }
  }
`;


const CarouselContainer = styled.div`
  position: relative;
  display: flex; 
  flex-wrap: wrap;
  justify-content: center;
  overflow-x: auto; 
  // margin-top: 20px;
  padding: 10px 0;
  gap: 50px;

  @media (max-width: 768px) {
    gap: 30px; 
  }

  @media (max-width: 480px) {
    flex-direction: column; 
    align-items: center; 
    gap: 30px;
  }
`;

const Slide = styled.div`
  width: 400px; 
  height: 400px; 
  position: relative;
  flex-shrink: 0;
  border-radius: 20px; 
  overflow: hidden; 
  transition: transform 0.5s ease; 

  &:hover {
    transform: translateY(-5px); 
    cursor:pointer;
  }

  @media (max-width: 768px) {
    width: 300px; 
    height: 300px;
  }

  @media (max-width: 480px) {
    width: 75%;
    height: 400px; 
  }
`;

const SlideImage = styled.img`
  width: 100%; 
  height: 100%; 
  object-fit: cover; 
  border-radius: 20px; 
  transition: transform 0.8s ease; 

  &:hover {
    transform: scale(1.1); 
  }

  @media (max-width: 768px) {
    border-radius: 15px; 
  }

  @media (max-width: 480px) {
    border-radius: 10px; 
  }
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0; 
  right: 0; 
  color: white; 
  background: rgba(0, 0, 0, 0.5); 
  padding: 15px;
  border-radius: 5px; 
  text-align: left;


  p{
    color:white;
    font-size:12px;
  }

  span{
    color:white;
    font-size:14px;
    display:flex;
    gap:5px;
    margin:2px;
    margin-bottom: 10px;
    align-items:center;
    text-decoration: underline;

    @media (max-width: 768px) {
      font-size: 12px;
      margin-left: 0;
    }

    @media (max-width: 480px) {
      font-size: 12px; 
      margin: 5px;
      margin-left: 0;
    }
  }

  h3 {
    font-size: 35px;
    font-weight: 350;
    margin: 10px 0; 

    @media (max-width: 768px) {
      font-size: 25px;
      margin-left: 0;
    }

    @media (max-width: 480px) {
      font-size: 25px; 
      margin: 5px;
      margin-left: 0;
    }
  }
`;

const FullscreenModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.95);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 30px;
  background: none;
  color: white;
  border: none;
  font-size: 28px;
  cursor: pointer;
  z-index: 10000;
`;

const CategoryInfo = styled.div`
  text-align: center;
  margin-top: 20px;
  max-width: 800px;
  color: #385963;

  h2 {
    margin-bottom: 10px;
  }

  p {
    margin: 0;
  }

  @media (max-width: 768px) {
    max-width: 90%;
    margin-bottom: 40px;
    h2 {
      font-size: 22px;
    }
    p {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    max-width: 80%;
     margin-bottom: 20px;
    h2 {
      font-size: 16px;
    }
    p {
      font-size: 10px;
    }
  }
`;

// File type constants
const FILE_PLACE_TYPE = {
  Gallery: 0,
  CategoryPhoto: 1,
  CoverPhoto: 2,
  Poster: 3,
};

const Amenities = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { i18n } = useTranslation();
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const tokenString = sessionStorage.getItem('token');
  const [showMapModal, setShowMapModal] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedGallery, setSelectedGallery] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(state?.categoryId || null);
  const [amenities, setAmenities] = useState([]);
  const [amenityCategories, setAmenityCategories] = useState([]);
  const [loading, setLoading] = useState(false); // NEW loading state
  
  const CATEGORY_PHOTO_PREFIX = 'CategoryPhoto_';
  const MISC_FILE_PREFIX = 'MiscFile_';
  const [galleryLoading, setGalleryLoading] = useState(false);

  const getCategoryPhotoFileName = (fileNames = []) =>
    fileNames.find(f => f.startsWith(CATEGORY_PHOTO_PREFIX));

  const getGalleryFileNames = (fileNames = []) =>
    fileNames.filter(f => !f.startsWith(CATEGORY_PHOTO_PREFIX) && !f.startsWith(MISC_FILE_PREFIX));


  useEffect(() => {
    if (state?.categoryId) {
      setSelectedCategoryId(state.categoryId);
    }
  }, [state?.categoryId]);

  // Fetch categories
  useEffect(() => {
    const fetchAmenityCategories = async () => {
      try {
        const response = await fetch(`${BASE_URL}AmenityCategory`);
        const data = await response.json();
        setAmenityCategories(data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchAmenityCategories();
  }, []);

  // Fetch amenities for selected category
  useEffect(() => {
    if (selectedCategoryId) {
      fetchAmenitiesByCategory(selectedCategoryId);
    }
  }, [selectedCategoryId]);

  
  const openGallery = async (amenity) => {
    const galleryFileNames = getGalleryFileNames(amenity.fileNames);
    if (galleryFileNames.length === 0) return;

    setShowModal(true);
    setGalleryLoading(true);
    setSelectedGallery([]);
    try {
      const fileResponse = await fetch(`${BASE_URL}Amenity/getFiles`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenString}`,
        },
        body: JSON.stringify(galleryFileNames),
      });
      if (!fileResponse.ok) throw new Error('Failed to fetch gallery photos');
      const galleryFiles = await fileResponse.json();
      setSelectedGallery(galleryFiles.map(f => `data:${f.mimeType};base64,${f.base64Content}`));
    } catch (error) {
      console.error('Error fetching gallery:', error);
    } finally {
      setGalleryLoading(false);
    }
  };

  const fetchAmenitiesByCategory = async (categoryId) => {
    setLoading(true);
    setAmenities([]);
    try {
      const response = await fetch(`${BASE_URL}Amenity/getByCategory/${categoryId}`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();

      // Render text content immediately, images pop in after
      setAmenities(data);
      setLoading(false);

      const categoryFileNames = data
        .map(dest => getCategoryPhotoFileName(dest.fileNames))
        .filter(Boolean);

      if (categoryFileNames.length > 0) {
        const fileResponse = await fetch(`${BASE_URL}Amenity/getFiles`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${tokenString}`,
          },
          body: JSON.stringify(categoryFileNames),
        });
        if (!fileResponse.ok) throw new Error('Failed to fetch cover photos');
        const coverFiles = await fileResponse.json();

        setAmenities(prev =>
          prev.map(dest => {
            const coverFileName = getCategoryPhotoFileName(dest.fileNames);
            const coverFile = coverFiles.find(f => f.fileName === coverFileName);
            return {
              ...dest,
              categoryBase64Src: coverFile
                ? `data:${coverFile.mimeType};base64,${coverFile.base64Content}`
                : null,
            };
          })
        );
      }
    } catch (error) {
      console.error('Error fetching amenities:', error);
      setLoading(false);
    }
  };

  return (
    <>
      <Header>
        <NavContainer>
          <NavTabs>
            {amenityCategories.map(category => (
              <li key={category.id} onClick={() => setSelectedCategoryId(category.id)}>
                <Link to="#" className={selectedCategoryId === category.id ? 'selected' : ''}>
                  {category.name[selectedLanguage]}
                </Link>
              </li>
            ))}
          </NavTabs>
          <hr style={{ margin: '20px 0', borderTop: '2px solid #538392', width: "90%", placeSelf: "center" }} />
          {selectedCategoryId && (
            <CategoryInfo>
              {(() => {
                const selectedCategory = amenityCategories.find(cat => cat.id === selectedCategoryId);
                if (!selectedCategory) return null;
                return (
                  <>
                    <h2>{selectedCategory.name[selectedLanguage]}</h2>
                    <p>{selectedCategory.description?.[selectedLanguage]}</p>
                  </>
                );
              })()}
            </CategoryInfo>
          )}
        </NavContainer>
      </Header>

      <MainContainer>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
            <div 
              className="spinner-border" 
              role="status" 
              style={{ 
                width: '4rem', 
                height: '4rem', 
                color: '#385963',   // your custom color
                borderColor: '#385963 transparent transparent transparent' // makes spinner border colored
              }}
            >
              <span className="visually-hidden">{i18n.t('loading')}</span>
            </div>
          </div>

        ) : amenities.length > 0 ? (
          <CarouselContainer>
            {amenities.sort((a, b) =>
    (a.name?.[selectedLanguage] || '').localeCompare(b.name?.[selectedLanguage] || '')
  )
  .map(amenity => (
              <Slide key={amenity.id}>
                <SlideImage
                  src={amenity.categoryBase64Src || imaaage}
                  alt={amenity.name[selectedLanguage] || amenity.name['en']}
                  style={{ opacity: amenity.categoryBase64Src ? 1 : 0.5, transition: 'opacity 0.3s' }}
                />
                <Overlay>
                  <h3>{amenity.name?.[selectedLanguage]}</h3>
                  <p>{amenity.description?.[selectedLanguage]}</p>
                  <div>
                    <span style={{ cursor: 'pointer' }} onClick={() => { navigator.clipboard.writeText(amenity.phone); alert(`${i18n.t('phone')} copied: ${amenity.phone}`); }}>
                      <PhoneSVG height={15} width={15} />{i18n.t('phone')}: {amenity.phone}
                    </span>
                    <span style={{ cursor: 'pointer' }} onClick={() => { navigator.clipboard.writeText(amenity.email); alert(`${i18n.t('email')} copied: ${amenity.email}`); }}>
                      <EmailSVG height={15} width={15} />{i18n.t('email')}: {amenity.email}
                    </span>
                        {amenity.websiteUrl && (
                    <span style={{ cursor: 'pointer' }}>
                      <a 
                        href={amenity.websiteUrl.startsWith('http') ? amenity.websiteUrl : `https://${amenity.websiteUrl}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px' }}
                      >
                        <WebsiteSVG height={15} width={15} />
                        {i18n.t('websiteUrl')}: {amenity.websiteUrl.replace(/(^\w+:|^)\/\//, '')} 
                      </a>
                    </span>
    )}
                    <span 
                      style={{ cursor: 'pointer' }} 
                      onClick={() => {
                        setSelectedPosition([amenity.location.latitude, amenity.location.longitude]);
                        setShowMapModal(true);
                      }}
                    >
                      <LocationSVG height={15} width={15} />{i18n.t('Location')}: {amenity.location.longitude}, {amenity.location.latitude}
                    </span>
                    {getGalleryFileNames(amenity.fileNames).length > 0 && (
                      <span
                        style={{ textDecoration: 'underline', cursor: 'pointer', display: 'block', marginBottom: '5px' }}
                        onClick={() => openGallery(amenity)}
                      >
                        <PhotoSVG height={15} width={15} style={{ marginRight: '5px' }} />{i18n.t('photos')}
                      </span>
                    )}
                  </div>
                </Overlay>
              </Slide>
            ))}
          </CarouselContainer>
        ) : (
          <Title>{i18n.t('selectCategory')}</Title>
        )}

        {showModal && (
          <FullscreenModal>
            <CloseButton onClick={() => setShowModal(false)}>X</CloseButton>
            {galleryLoading ? (
              <div className="spinner-border" role="status" style={{ color: 'white' }}>
                <span className="visually-hidden">{i18n.t('loading')}</span>
              </div>
            ) : (
              <PhotoGallery photos={selectedGallery} />
            )}
          </FullscreenModal>
        )}

        {showMapModal && selectedPosition && (
          <MapModal
            position={selectedPosition}
            onClose={() => setShowMapModal(false)}
          />
        )}

      </MainContainer>
    </>
  );
};

export default Amenities;











